import axios from 'axios';

const client = axios.create({
  baseURL: 'https://api-hvac.skshieldus.com/admin',
});

export const serviceClient = axios.create({
  baseURL: 'https://api-hvac.skshieldus.com',
});

export const appClient = axios.create({
  baseURL: 'https://app-hvac.skshieldus.com',
});

client.interceptors.response.use(
  response => response,
  async error => {
    if (error.response.data.error === 'BadAccessToken') {
      localStorage.clear();
      window.location.href = '/';
    }
  },
);

export default client;
